(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('OrganoRelevanteDialogController', OrganoRelevanteDialogController);

    OrganoRelevanteDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'OrganoRelevante', 'Norma', 'Organo'];

    function OrganoRelevanteDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, OrganoRelevante, Norma, Organo) {
        var vm = this;

        vm.organoRelevante = entity;
        vm.clear = clear;
        vm.save = save;
        vm.normas = Norma.query();
        vm.organos = Organo.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.organoRelevante.id !== null) {
                OrganoRelevante.update(vm.organoRelevante, onSaveSuccess, onSaveError);
            } else {
                OrganoRelevante.save(vm.organoRelevante, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('sgnmrApp:organoRelevanteUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
